import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PAGE_LIMIT } from '../../config';
import useApiList from '../../hooks/useApiList';
import List from '../common/List';
import ExhibitorItem from './ExhibitorItem';
import Loader from '../common/Loader';
import Error from '../common/Error';
import Pager from '../common/Pager';
import ModeSwitch from '../common/ModeSwitch';
import FilterInfo from '../filter/FilterInfo';
import { skipSet } from '../../store/filterSlice';
import './ExhibitorList.css';

const ExhibitorList = ({ event }) => {
	const { i18n } = useTranslation();
	const dispatch = useDispatch();
	const lang = i18n.language;
	const method = '/exhibitors/search';
	const limit = PAGE_LIMIT;
    const skip = useSelector(state => state.filter.skip);
	const find = useSelector(state => state.filter.find);
	const where = useSelector(state => state.filter.where);
	const dates = useSelector(state => state.filter.dates);
	const categories = useSelector(state => state.filter.categories);
	const countries = useSelector(state => state.filter.countries);
	const [ data, error, isLoading ] = useApiList({ method, limit, find, skip, event: event._id, categories, lang, where, countries, dates });

	// Для переключения страниц из пейджера
	const setSkip = (skip) => {
		dispatch(skipSet(skip));
	};
/*
	// ВНИМАНИЕ:
	// При возврате ответа сервера может быть изменена область
	// поиска с index на everywhere если по index ничего не нашли.
	// По уму надо бы подкрасить соответствующую плашку в фильтре,
	// но это оказалось нетривиально т.к. если мы здесь установим
	// в фильтре область поиска, мы вызовем сайд-эффект: 
	// неустойчивое переключение области поиска при клике на плашку
	// в фильтре с сопутствующим множественным обращением к серверу.
	// Выяснить почему так происходит не хватило времени.
	useEffect(() => {
		if(data && data.where !== where) {
			dispatch(whereSet(data.where));
			console.log('Устанавливаем where: ' + where + ' => ' + data.where);
		}
	}, [ data, where, dispatch ]);
*/
	return (
		<div className='Content-main ExhibitorList'>
			<div className='desktop'>
	    		<h1>{event.name[lang]}</h1>
			</div>

			<ModeSwitch data={data}/>

			{isLoading && <Loader/>}
			{error && <Error error={error}/>}

			<FilterInfo data={data}/>

			{data && 
			<React.Fragment>
				<List>
				{data.exhibitors.map(exhibitor => (
					<ExhibitorItem
						key={exhibitor._id}
						exhibitor={exhibitor}
					/>
				))}
				</List>
				<Pager skip={skip} setSkip={setSkip} limit={limit} total={data.total}/>
			</React.Fragment>}
		</div>
	);
};

ExhibitorList.propTypes = {
    event: PropTypes.object.isRequired,
};

export default ExhibitorList;
